module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "font-size": "53px",
      "color": "#999",
      "text-align": "center",
      "padding-top": "40px"
    }
  }, [_vm._v("Freshin")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "27px",
      "color": "#666",
      "text-align": "center"
    }
  }, [_vm._v("Admin Login")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-tabs', {
    staticStyle: {
      "width": "400px",
      "display": "inline-block"
    },
    attrs: {
      "defaultActiveKey": "1",
      "size": "large"
    }
  }, [_c('a-tab-pane', {
    key: "1",
    attrs: {
      "tab": "账户密码登录"
    }
  }, [_c('a-form', {
    staticClass: "login-form",
    attrs: {
      "id": "login",
      "form": _vm.form
    },
    on: {
      "submit": _vm.handleSubmit
    }
  }, [_c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ([
        'username',
        {
          rules: [{
            required: true,
            whitespace: true,
            pattern: /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/,
            message: '请输入正确的邮箱!'
          }]
        }
      ]),
      expression: "[\n\t\t\t\t          'username',\n\t\t\t\t          { rules: [{ required: true, whitespace:true, pattern: /^(\\w-*\\.*)+@(\\w-?)+(\\.\\w{2,})+$/, message: '请输入正确的邮箱!' }] }\n\t\t\t\t        ]"
    }],
    attrs: {
      "size": "large",
      "placeholder": "邮箱"
    }
  }, [_c('a-icon', {
    staticStyle: {
      "color": "rgba(0,0,0,.25)"
    },
    attrs: {
      "slot": "prefix",
      "type": "user"
    },
    slot: "prefix"
  })], 1)], 1), _vm._v(" "), _c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ([
        'password',
        {
          rules: [{
            required: true,
            message: '请输入你的密码!'
          }]
        }
      ]),
      expression: "[\n\t\t\t\t          'password',\n\t\t\t\t          { rules: [{ required: true, message: '请输入你的密码!' }] }\n\t\t\t\t        ]"
    }],
    attrs: {
      "size": "large",
      "type": "password",
      "placeholder": "密码"
    }
  }, [_c('a-icon', {
    staticStyle: {
      "color": "rgba(0,0,0,.25)"
    },
    attrs: {
      "slot": "prefix",
      "type": "lock"
    },
    slot: "prefix"
  })], 1)], 1), _vm._v(" "), _c('a-form-item', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('a-checkbox', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ([
        'remember',
        {
          valuePropName: 'checked',
          initialValue: true,
        }
      ]),
      expression: "[\n\t\t\t\t          'remember',\n\t\t\t\t          {\n\t\t\t\t            valuePropName: 'checked',\n\t\t\t\t            initialValue: true,\n\t\t\t\t          }\n\t\t\t\t        ]"
    }]
  }, [_vm._v("\n\t\t\t\t\t\t\t自动登录\n\t\t\t\t\t\t")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.forgot
    }
  }, [_vm._v("忘记密码?")]), _vm._v(" "), _c('a-button', {
    staticClass: "login-form-button",
    attrs: {
      "size": "large",
      "type": "primary",
      "html-type": "submit"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t登录\n\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('a-tab-pane', {
    key: "2",
    attrs: {
      "tab": "扫码登录",
      "disabled": "",
      "forceRender": ""
    }
  }, [_vm._v("Content of Tab Pane 2")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "bottom": "30px",
      "text-align": "center",
      "width": "100%",
      "font-size": "12px"
    }
  }, [_vm._v("powered by Freshin")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef63890a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/login/index.vue
// module id = 2403
// module chunks = 1